import React from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Actions from '../../actions/App';
import * as RT from '../../constants/Routing';

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => { };

  _signOut = e => {
    e.preventDefault();
    localStorage.removeItem('logged_in');
    localStorage.removeItem('current_user');
    localStorage.removeItem('access_token');
    this.props.history.push(RT.SIGN_IN_PATH);
  };

  render = () => {
    const currentPath = this.props.match.path.replace(/\/$/, '');
    let isTaskGroup = [
      RT.TASK_INDEX_PATH,
      RT.TASK_NEW_PATH,
      RT.TASK_PREVIEW_PATH,
      RT.TASK_OLD_INDEX_PATH,
      RT.TASK_SHOW_PATH,
      RT.TASK_DUPLICATE_PATH
    ].includes(currentPath);

    if (currentPath === RT.TASK_EDIT_PATH) {
      isTaskGroup = true;
    }

    return (
      <div className="sidebar">
        <ul>
          <li>
            <Link to={RT.TOP_PATH} className={currentPath === RT.TOP_PATH ? 'active' : ''}>
              トップページ
            </Link>
          </li>
          <li className="no-pad">
            <ul>
              <li className={!isTaskGroup ? 'list-header no-bottom-border' : 'list-header'}>
                <Link to={RT.TASK_INDEX_PATH} className={isTaskGroup ? 'active' : ''}>
                  タスク
                </Link>
              </li>
              <li className={!isTaskGroup ? 'hidden' : ''}>
                <Link
                  to={RT.TASK_NEW_PATH}
                  className={
                    currentPath === RT.TASK_NEW_PATH || currentPath === RT.TASK_DUPLICATE_PATH
                      ? 'active'
                      : ''
                  }
                >
                  新規タスクの登録
                </Link>
              </li>
              <li className={!isTaskGroup ? 'hidden' : ''}>
                <Link
                    to={RT.TASK_INDEX_PATH}
                    className={
                      currentPath === RT.TASK_INDEX_PATH || currentPath === RT.TASK_SHOW_PATH
                          ? 'active'
                          : ''
                    }
                >
                  タスク管理
                </Link>
              </li>
              <li className={!isTaskGroup ? 'hidden' : ''}>
                <Link
                    to={RT.TEMPLATE_PATH}
                    className={
                      currentPath === RT.TEMPLATE_PATH || currentPath === RT.TEMPLATE_PATH
                          ? 'active'
                          : ''
                    }
                >
                  注意事項テンプレ
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to={RT.PAYMENT_PATH} className={currentPath === RT.PAYMENT_PATH ? 'active' : ''}>
              ご利用金額
            </Link>
          </li>
          <li>
            <Link
              to={RT.SETTING_EDIT_PATH}
              className={currentPath === RT.SETTING_EDIT_PATH ? 'active' : ''}
            >
              事業者情報
            </Link>
          </li>
          <li>
            <Link to={RT.FAQ_PATH} className={currentPath === RT.FAQ_PATH ? 'active' : ''}>
              よくある質問
            </Link>
          </li>
        </ul>
      </div>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
